/* eslint-disable */
import { PersonsReduxState } from '@qwealth/qdata';
import { pathOr } from 'ramda';
import { createSelector } from 'reselect';

export type State = {
  persons?: PersonsReduxState;
};

export const selectPersonsRoot: (s: State) => PersonsReduxState = pathOr({}, ['persons']);

// @ts-ignore
export const selectPersonIds = createSelector(
  // @ts-ignore
  state => state.householdMetadata.members,
  // @ts-ignore
  members => members.map(({ QID }) => QID),
);
